import Substance from "@/views/product/components/product-card/composition/SubstanceV4.vue";

export {
    Substance
};
